import React from 'react';
import './Logo.scss'

function Logo(props) {
  return (
    <span className="logo">ÉDITEUR</span>
  );
}

export default Logo;
